import angular from 'angular';

import mediaTemplatesRouting from './media-templates-routing-module';
import CmsMediaTemplatesComponent from './media-templates-component';
import TemplateTabComponent from './components/template-tab/template-tab-component';
import PosterPreviewFormDialogComponent from './components/poster-preview-form/poster-preview-form-dialog-component';


export default angular
  .module('media-templates', [
    mediaTemplatesRouting.name,
    'multi-language',
  ])
  .component('cmsMediaTemplates', new CmsMediaTemplatesComponent())
  .component('posterPreviewFormDialog', new PosterPreviewFormDialogComponent())
  .component('templateTab', new TemplateTabComponent());



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/media-templates/media-templates-module.js